const AFFIRMATIVE_WORDS = new Set([
  'yes', 'yeah', 'yep', 'yup', 'yah', 'ya', 'yea', 'yeh', 'yas',
  'sure', 'ok', 'okay', 'of course',
  'si', 'sí', 'see', 'claro', 'dale', 'bueno', 'acepto', 'aceptar', 'de acuerdo',
]);

const NEGATIVE_WORDS = new Set([
  'no', 'nah', 'nope', 'naah', 'nay', 'never', 'nuh',
  'rechazar', 'rechazo', 'niego', 'nunca', 'jamás',
]);

export function normalizeShortAnswer(text) {
  if (!text || typeof text !== 'string') return text;

  const trimmed = text.trim();
  const wordCount = trimmed.split(/\s+/).length;

  if (wordCount > 2) return trimmed;

  const lower = trimmed.toLowerCase().replace(/[.,!?;:]+$/, '');

  if (AFFIRMATIVE_WORDS.has(lower)) return 'Si';
  if (NEGATIVE_WORDS.has(lower)) return 'No';

  return trimmed;
}
